import PropTypes from 'prop-types';
import * as headings from './style';

function Heading({ as = 'h1', children, className, id }) {
  const tag = as?.toUpperCase() ?? 'H1';
  const StyledHeading = headings[tag] || headings.H1;

  return (
    <StyledHeading className={className} id={id}>
      {children}
    </StyledHeading>
  );
}

Heading.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  id: PropTypes.string,
};

export default Heading;
